import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import { SelectChangeEvent } from '@mui/material/Select'
import { ControlNature } from '../../utils/constants'
import { systemLabel } from '../../utils/systemLabel'
import { useTranslation } from 'react-i18next'
import '../../i18n'

interface SelectControlNatureProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void
}

const SelectcontrolNature: React.FC<SelectControlNatureProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation()
  console.log('value', value)
  return (
    <FormControl fullWidth>
      <InputLabel id="statut-label">{t('Control Nature')}</InputLabel>
      <Select
        labelId="statut-label"
        id="ControlNature"
        name="ControlNature"
        value={value}
        label="Controle Nature"
        onChange={onChange}
      >
        {ControlNature.map((Control, index) => (
          <MenuItem key={index} value={Control}>
            {systemLabel(t, 'controlNature', Control)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectcontrolNature
